import React from 'react';

import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { token } from '@atlaskit/tokens';
import { R400 } from '@atlaskit/theme/colors';

type WarningIconProps = {
	label: string;
};

export const ConfluenceWarningIcon = ({ label }: WarningIconProps) => {
	return (
		<WarningIcon label={label} LEGACY_size="medium" color={token('color.icon.danger', R400)} />
	);
};
